import React from "react";
import { LEAD_TEMPERATURES } from "../../constants";

const PlatformTemperatureBadge = ({ temperature }) => {
    const config = LEAD_TEMPERATURES[temperature] || LEAD_TEMPERATURES.cold;
    return (
        <span className={`badge rounded-pill crm-temp-badge temp-${temperature || "cold"}`}>
            {config.label}
        </span>
    );
};

export default PlatformTemperatureBadge;
